import { atom, useAtom } from 'jotai';
import { atomFamily } from 'jotai/utils';

export interface TooltipKeyValueRow {
    label: string;
    value: string;
}

export type TooltipContent = string | TooltipKeyValueRow[];

const tooltipIsOpenAtomGroup = atomFamily((_) => atom(false));
const tooltipContentAtomGroup = atomFamily((_) => atom<TooltipContent>(''));
const tooltipTopPositionAtomGroup = atomFamily((_) => atom(0));
const tooltipLeftPositionAtomGroup = atomFamily((_) => atom(0));

export const useTooltipController = ({
    tooltipGroupName,
}: {
    tooltipGroupName: string;
}) => {
    const [isTooltipOpen, setIsTooltipOpen] = useAtom(
        tooltipIsOpenAtomGroup(tooltipGroupName),
    );
    const [tooltipContent, setTooltipContent] = useAtom(
        tooltipContentAtomGroup(tooltipGroupName),
    );
    const [tooltipTopPosition, setTooltipTopPosition] = useAtom(
        tooltipTopPositionAtomGroup(tooltipGroupName),
    );
    const [tooltipLeftPosition, setTooltipLeftPosition] = useAtom(
        tooltipLeftPositionAtomGroup(tooltipGroupName),
    );

    return {
        isTooltipOpen,
        tooltipContent,
        tooltipTopPosition,
        tooltipLeftPosition,
        setIsTooltipOpen,
        setTooltipContent,
        setTooltipTopPosition,
        setTooltipLeftPosition,
    };
};
